<template>
  <div class="wrapper">
    <!-- LIST VIEW -->

    <v-list-item three-line v-if="!gridView" dense :class="mediaTypeColor">
      <v-checkbox
        v-if="showCheckbox"
        v-model="isChecked"
        @change="$emit('changeChecked', $event)"
        color="primary"
        class="mr-2"
      ></v-checkbox>
      <v-list-item-avatar color="grey">
        <v-icon medium>title</v-icon>
      </v-list-item-avatar>
      <v-list-item-content class="pl-4">
        <v-list-item-title class="subtitle-1">
          <span v-html="descriptionText"></span>
        </v-list-item-title>
        <v-list-item-subtitle
          >{{ mediaTypeDescription }}
          <span
            v-if="
              media.mediaTypeId !== mediaTypesEnum.poi_image ||
                media.mediaTypeId !== mediaTypesEnum.poi_image_dzi
            "
            >{{ mediaDetailsDescription }}</span
          ></v-list-item-subtitle
        >
        <!--        <v-list-item-subtitle>{{ media.url }}</v-list-item-subtitle>-->
        <!--        <v-list-item-subtitle>{{ media.mediaData.path }}</v-list-item-subtitle>-->
      </v-list-item-content>

      <v-list-item-action v-if="!isChecked && !hideActions">
        <v-list-item-subtitle>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="gray text-subtitle-2"
                >updated {{ media.updatedAt | moment('from', 'now') }}
                <v-icon class="gray text-subtitle-2"
                  >mdi-information-outline</v-icon
                ></span
              >
            </template>
            <p>
              Created:
              {{ media.createdAt | moment('dddd, MMMM Do YYYY, h:mm:ss a')
              }}<br />
              Last updated:
              {{ media.updatedAt | moment('dddd, MMMM Do YYYY, h:mm:ss a') }}
            </p>
            <p></p>
          </v-tooltip>
        </v-list-item-subtitle>

        <div class="text-xs-right">
          <!-- <v-btn
            icon
            color="orange"
            v-on:click="openAddToGalleryDialog()"
            title="Add to Gallery"
          >
            <v-icon>mdi-image-album</v-icon>
          </v-btn> -->
          <v-btn
            icon
            v-on:click="removeMediaItem()"
            color="error"
            title="Delete"
          >
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
          <v-btn icon v-on:click="edit()" title="Edit">
            <v-icon>edit</v-icon>
          </v-btn>
        </div>
      </v-list-item-action>
    </v-list-item>
    <v-divider v-if="!gridView">&nbsp;</v-divider>

    <!-- GRID VIEW -->
    <v-card
      :color="mediaTypeColor"
      max-width="250"
      min-width="250"
      v-if="gridView"
      @click="$emit('changeChecked', $event)"
      :outlined="checked"
    >
      <v-list-item>
        <v-list-item-avatar color="grey">
          <v-icon medium>title</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="subtitle-1">
            {{ mediaTypeDescription }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="gray text-subtitle-2"
                  >updated {{ media.updatedAt | moment('from', 'now') }}
                  <v-icon class="gray text-subtitle-2"
                    >mdi-information-outline</v-icon
                  ></span
                >
              </template>
              <p>
                Created:
                {{ media.createdAt | moment('dddd, MMMM Do YYYY, h:mm:ss a')
                }}<br />
                Last updated:
                {{ media.updatedAt | moment('dddd, MMMM Do YYYY, h:mm:ss a') }}
              </p>
              <p></p>
            </v-tooltip>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            {{ mediaDetailsDescription }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-text>
        <span v-html="descriptionText"></span>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click.stop="removeMediaItem()"
          color="error"
          title="Delete"
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
        <v-btn icon @click.stop="edit()" title="Edit">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-card-actions>

      <v-fade-transition>
        <v-overlay v-if="checked" absolute color="white" opacity="0.6">
        </v-overlay>
      </v-fade-transition>
    </v-card>

    <add-to-gallery-dialog
      v-if="showAddToGalleryDialog"
      :showDialog="showAddToGalleryDialog"
      @cancel="closeAddToGalleryDialog"
      @done="closeAddToGalleryDialog"
    ></add-to-gallery-dialog>
  </div>
</template>

<script>
import AddToGalleryDialog from '../AddToGalleryDialog'
import Enums from '../../helpers/Enums'
export default {
  components: {
    AddToGalleryDialog
  },
  props: {
    media: {
      type: Object,
      required: true,
      default: function() {
        return {}
      }
    },
    gridView: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    showCheckbox: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    checked: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    },
    hideActions: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    }
  },

  created: function() {
    this.getMediaContent(this.$props.media)
  },
  computed: {
    showAddToGalleryDialog: {
      get: function() {
        return this.showDialog
      },
      set: function(newValue) {
        this.showDialog = newValue
      }
    }
  },
  methods: {
    edit() {
      this.$emit('edit', this.media.id)
      // var self = this
      // this.$store
      //   .dispatch('MediaStore/setSelectedMediaItem', this.media.id, {
      //     root: true
      //   })
      //   .then(res => {
      //     self.$emit('edit')
      //   })
    },
    getMediaContent: function(media) {
      this.name = media.name

      this.mediaTypesEnum = Enums.MediaType

      this.mediaTypeDescription = 'Title'
      this.mediaDetailsDescription = Enums.lang[media.langId].name
      this.mediaTypeColor = 'blue darken-1'
      if (media.textualContent) {
        this.descriptionText = media.textualContent.replace(
          /(\\r)*\\n/g,
          '<br>'
        )
      }
    },
    removeMediaItem: function() {
      this.$emit('deleted', this.media.id)
      // this.$store.dispatch('MediaStore/deleteMedia', this.media.id)
      // NOT IMPLEMENTED
    },
    openAddToGalleryDialog: async function() {
      if (!this.showAddToGalleryDialog) {
        await this.$store.dispatch(
          'MediaStore/setSelectedMediaItem',
          this.media.id
        )
        await this.$store.dispatch(
          'MediaStore/getSelectedMediaItemParentGalleries'
        )
        this.showAddToGalleryDialog = true
      }
    },
    closeAddToGalleryDialog: function() {
      if (this.showAddToGalleryDialog) {
        this.showAddToGalleryDialog = false
      }
    },
    handleCardClick: function(event) {
      this.$emit('changeChecked', event)
    }
  },
  data: function() {
    return {
      isChecked: this.checked,
      name: '',
      bannerImageUrl: './assets/default_file_icon.png',
      descriptionText: '',
      mediaTypeDescription: '',
      mediaDetailsDescription: '',
      mediaFileDescription: '',
      showDialog: false,
      mediaTypeColor: 'blue darken-4'
    }
  }
}
</script>

<style scoped>
.wrapper {
  border-radius: 6px;
  overflow: hidden;
}
.text-xs-right {
  white-space: nowrap;
}
</style>
